// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'circle-stacked';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.031 6.875a5.844 5.844 0 1 0 11.688 0 5.844 5.844 0 0 0-11.688 0z' />
    <path d='M6.613 14.837a5.844 5.844 0 1 0 8.224-8.224' />
  </g>
);

export const viewBox = '0 0 18 18';
